import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Pagination from '../../pagination/pagination.component';
import JobCard from './job-card.component';

// styles , icons and images
import { Row, Col } from 'react-bootstrap';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Paper } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';


// this component job posts in the posts page

export default class JobPosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterBy : 'Latest'
        }
    }
    callBack = (data) => {
        if (data === "update") {
            this.props.callBack(data)
        }
    }
    componentWillReceiveProps(props, nextprops) {
        if (props !== nextprops) {
            this.setState({ ...this.state, type: props.type , data : props.data.data})
        }
    }
    toggleFilter = () => {
        if(this.state.filterBy === 'Latest'){
            this.setState({ ...this.state, filterBy : 'Newest'})
        }else{
            this.setState({ ...this.state, filterBy : 'Latest'})
        }
    }
    render() {
        if(!this.props.data) {
            return (
                <div className="">
                    <Skeleton className="mb-2" variant="rect" animation="wave" height={260} />
                </div>
            )
        }
        else {
            return (
                <div style={{ borderTop: '3px solid #e85a19' }}>
                    <div className="container-responsive">
                        <Paper elevation={3}>
                            <Row elevation={3} className="bg-light m-0 p-3" style={{ borderBottom: '1px solid #f2f2f2' }}>
                                <Col className="text-right p-0" xs={12}>
                                    <h6 className="bold mb-0"
                                    >Sort by:
                                    <Link className="text-orange" to=''
                                            onClick={e => {
                                                e.preventDefault();
                                                this.setState({...this.state , data : this.state.data.reverse()})
                                                this.toggleFilter();
                                            }}> {this.state.filterBy}</Link> <ExpandMoreIcon /></h6>
                                </Col>
                            </Row>
                            <Pagination card={this.state.data}>
                                <JobCard type={this.props.type ? this.props.type : ''} callBack={this.callBack} />
                            </Pagination>
                        </Paper>
                    </div>
                </div>
            );
        }

    }
}